import React, { useEffect, useState } from 'react';
import { chatbotNotificationService } from '../../../services/chatbotNotificationService';
// import { chatbotService } from '../../../services/chatbotService';
import { toast } from 'react-toastify';

const NotificationsTab = ({ chatbot }: any) => {
    const chatbotId = chatbot?.id;

    const [departments, setDepartments] = useState<any[]>([]);
    const [staff, setStaff] = useState<any[]>([]);

    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [selectedStaff, setSelectedStaff] = useState<string[]>([]);
    const [emailEnabled, setEmailEnabled] = useState(true);

    const [newDept, setNewDept] = useState('');
    const [newStaff, setNewStaff] = useState({
        name: '',
        email: '',
        departmentId: ''
    });

    /* ================= LOAD ================= */

    const loadData = async () => {
        if (!chatbotId) return;

        try {
            const [depRes, staffRes] = await Promise.all([
                chatbotNotificationService.listDepartments(chatbotId),
                chatbotNotificationService.listStaff(chatbotId)
            ]);

            setDepartments(depRes);
            setStaff(staffRes);
        } catch {
            toast.error('Failed to load notification data');
        }
    };

    useEffect(() => {
        loadData();
    }, [chatbotId]);

    /* ================= LOAD CONFIG ================= */

    useEffect(() => {
        const config = chatbot?.config?.notifications;

        if (config) {
            setSelectedDepartment(config.departmentId || '');
            setSelectedStaff(config.staffIds || []);
            setEmailEnabled(config.emailEnabled ?? true);
        }
    }, [chatbot]);

    /* ================= CREATE ================= */

    const createDepartment = async () => {
        if (!newDept) return;

        await chatbotNotificationService.createDepartment({
            chatbotId,
            name: newDept
        });

        setNewDept('');
        loadData();
    };

    const createStaff = async () => {
        if (!newStaff.name || !newStaff.email || !newStaff.departmentId) return;

        await chatbotNotificationService.createStaff(newStaff);

        setNewStaff({ name: '', email: '', departmentId: '' });
        loadData();
    };

    /* ================= FILTER STAFF ================= */

    const filteredStaff = staff.filter(
        (s) => s.departmentId === selectedDepartment
    );

    /* ================= SAVE CONFIG ================= */

    // const saveConfig = async () => {
    //     await chatbotService.updateChatbot(chatbotId, {
    //         config: {
    //             ...(chatbot.config || {}),
    //             notifications: {
    //                 departmentId: selectedDepartment,
    //                 staffIds: selectedStaff,
    //                 emailEnabled
    //             }
    //         }
    //     });

    //     toast.success('Saved successfully');
    // };

    /* ================= UI ================= */

    return (
        <div className="p-6 space-y-8">

            {/* EMAIL */}
            {/* <div className="flex justify-between border p-4 rounded-lg">
                <span>Email Notifications</span>
                <input type="checkbox" checked={emailEnabled} onChange={(e) => setEmailEnabled(e.target.checked)} />
            </div> */}

            {/* DEPARTMENTS */}
            <div>
                <h3 className="font-semibold mb-2">Departments</h3>

                <div className="flex gap-2 mb-3">
                    <input
                        value={newDept}
                        onChange={(e) => setNewDept(e.target.value)}
                        placeholder="Department name"
                        className="border p-2 rounded w-full"
                    />
                    <button onClick={createDepartment} className="bg-blue-600 text-white px-4 rounded">
                        Add
                    </button>
                </div>

                <select
                    value={selectedDepartment}
                    onChange={(e) => {
                        setSelectedDepartment(e.target.value);
                        setSelectedStaff([]);
                    }}
                    className="border p-2 rounded w-full"
                >
                    <option value="">Select Department</option>
                    {departments.map((d) => (
                        <option key={d.id} value={d.id}>{d.name}</option>
                    ))}
                </select>
            </div>

            {/* STAFF */}
            <div>
                <h3 className="font-semibold mb-2">Staff</h3>

                <div className="grid grid-cols-3 gap-2 mb-3">
                    <input
                        placeholder="Name"
                        value={newStaff.name}
                        onChange={(e) => setNewStaff({ ...newStaff, name: e.target.value })}
                        className="border p-2 rounded"
                    />
                    <input
                        placeholder="Email"
                        value={newStaff.email}
                        onChange={(e) => setNewStaff({ ...newStaff, email: e.target.value })}
                        className="border p-2 rounded"
                    />
                    <select
                        value={newStaff.departmentId}
                        onChange={(e) => setNewStaff({ ...newStaff, departmentId: e.target.value })}
                        className="border p-2 rounded"
                    >
                        <option value="">Department</option>
                        {departments.map((d) => (
                            <option key={d.id} value={d.id}>{d.name}</option>
                        ))}
                    </select>
                </div>

                <button onClick={createStaff} className="bg-blue-600 text-white px-4 py-2 rounded mb-3">
                    Add Staff
                </button>

                <div className="grid md:grid-cols-2 gap-3">
                    {filteredStaff.map((s) => (
                        <div
                            key={s.id}
                            onClick={() =>
                                setSelectedStaff((prev) =>
                                    prev.includes(s.id)
                                        ? prev.filter((x) => x !== s.id)
                                        : [...prev, s.id]
                                )
                            }
                            className={`p-3 border rounded cursor-pointer ${selectedStaff.includes(s.id) ? 'bg-blue-50 border-blue-500' : ''
                                }`}
                        >
                            <div>{s.name}</div>
                            <div className="text-sm text-gray-500">{s.email}</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* SAVE */}
            {/* <div className="flex justify-end">
                <button onClick={saveConfig} className="bg-agentic-primary-blue text-white px-5 py-2 rounded">
                    Save Configuration
                </button>
            </div> */}

        </div>
    );
};

export default NotificationsTab;
